// init search focus on open
export default function initSearchFocusOnOpen() {
	jQuery('#search-form').each(function () {
		this.addEventListener('shown.bs.collapse', function () {
			jQuery(this).find('input[type="text"], input[type="search"]').eq(0).focus();
		});
	})
}
